import React, { Component } from 'react'
import { ResponsiveBullet } from '@nivo/bullet'
import Spinner from '../../../../UI/Spinner/Spinner'
import Grid from '@material-ui/core/Grid'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import Divider from '@material-ui/core/Divider'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Box from '@material-ui/core/Box'

class form extends Component {
  state = {
    form: [],
    data: [
      {
        id: '%เป้าหมาย',
        ranges: [20, 40, 60, 80, 100, 120],
        measures: [81],
        markers: [99]
      }
    ]
  }

  static getDerivedStateFromProps = (props, state) => {}

  getBullet = item => {
    let bulletRanges = []
    let color = []
    item.threshold.map(v => {
      bulletRanges.push(+v.end_value)
      color.push(v.color_code)
      return v
    })
    return {
      data: [
        {
          id: '%เป้าหมาย',
          ranges: bulletRanges,
          measures: [item.actual_value],
          markers: [item.target_value]
        }
      ],
      color: color
    }
  }
  render() {
    const StyledExpansionPanelSummary = withStyles({
      root: {
        backgroundColor: '#2aaeff',
        color: 'white'
      }
    })(ExpansionPanelSummary)
    let Form = <Spinner />
    if (this.props.form.length !== 0) {
      let org = []
      this.props.form.map(item => {
        if (!org.find(br => br.org_name === item.org_name)) {
          org.push({ org_name: item.org_name, result_score: item.result_score })
        }
        return item
      })
      const detail = orgName => {
        return this.props.form.map((item, index) => {
          if (item.org_name === orgName) {
            return (
              <Aux>
                <Grid
                  item
                  xs={4}
                  direction='column'
                  justify='flex-start'
                  alignItems='center'
                  style={{
                    border: '1px solid darkgray',
                    height: '150px',
                    backgroundColor: index % 2 === 0 ? '#f7f9f9' : 'white'
                  }}>
                  <Grid item xs={12}>
                    {`มุมมอง : ${item.item_name}`}
                  </Grid>
                  <Grid item>{`ตัวชี้วัด : ${item.org_name}`}</Grid>
                  <Grid item xs={12}>
                    {`หน่วยวัด : ${item.uom_name}`}
                  </Grid>
                </Grid>
                <Grid
                  item
                  direction='row'
                  justify='flex-start'
                  alignItems='center'
                  style={{
                    border: '1px solid darkgray',
                    height: '150px',
                    backgroundColor: index % 2 === 0 ? '#f7f9f9' : 'white'
                  }}
                  xs={8}>
                  <Grid item xs={4}>
                    {`เป้า : ${item.target_value}`}
                  </Grid>
                  <Grid item xs={4}>
                    {`ผลงาน : ${item.actual_value}`}
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ widht: '60px', height: '45px' }}>
                      <ResponsiveBullet
                        data={this.getBullet(item).data}
                        margin={{ top: 5, right: 20, bottom: 20, left: 60 }}
                        spacing={20}
                        titleAlign='start'
                        titleOffsetX={-55}
                        measureSize={0.25}
                        markerSize={1}
                        markerColors={'white'}
                        animate={true}
                        motionStiffness={20}
                        motionDamping={12}
                        measureColors={'black'}
                        rangeColors={this.getBullet(item).color}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Divider />
              </Aux>
            )
          } else {
            return null
          }
        })
      }
      Form = org.map(orgItem => (
        <ExpansionPanel>
          <StyledExpansionPanelSummary
            expandIcon={
              <ExpandMoreIcon
                style={{
                  color: 'white'
                }}
              />
            }
            aria-controls='panel1a-content'
            id='panel1a-header'>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item xs={11}>
                <Typography>{orgItem?.org_name}</Typography>
              </Grid>
              <Grid item xs={1}>
                <Box position='relative' display='inline-flex'>
                  <CircularProgress
                    color={'inherit'}
                    variant='static'
                    value={+orgItem?.result_score > 100 ? 100 : +orgItem?.result_score}
                  />
                  <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position='absolute'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'>
                    <Typography
                      variant='caption'
                      component='div'
                      style={{
                        color: 'white'
                      }}>{`${Math.round(orgItem?.result_score)}%`}</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </StyledExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid
              container
              direction='row'
              justify='flex-start'
              alignItems='center'
              spacing={3}
              style={{ border: '1px solid darkgray' }}>
              {detail(orgItem?.org_name)}
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      ))
    }
    return <div>{Form}</div>
  }
}

export default form
